<template>
  <div class="menu-item-content">
    <svg-icon :icon="icon" class="menu-icon"></svg-icon>
    <span class="menu-title">{{ title }}</span>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  title: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    default: 'link'
  }
})
</script>

<style lang="scss" scoped>
.menu-item-content {
  display: flex;
  align-items: center;

  .menu-icon {
    margin-right: 10px;
    font-size: 17px;
    flex-shrink: 0;
  }

  .menu-title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
